// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

import Image from '@nerdwallet/react-image';
import VerticalSpacer from '../vertical-spacer/vertical-spacer';

import { stringTextAreaSpec, stringInputSpec } from '../../lib/editing-configs';

const TwoColImage = ({
  imageAlt,
  imageHeightDesktop,
  imageHeightMobile,
  imageUrlDesktop,
  imageUrlMobile,
  imageWidthDesktop,
  imageWidthMobile,
  size,
}) => {
  let imageUrl = imageUrlDesktop;
  let imageHeight = imageHeightDesktop;
  let imageWidth = imageWidthDesktop;
  if (size === 'sm') {
    imageHeight = imageHeightMobile || imageHeightDesktop;
    imageUrl = imageUrlMobile || imageUrlDesktop;
    imageWidth = imageWidthMobile || imageWidthDesktop;
  }

  return (
    <div className="row-two-col__image" style={{ maxWidth: `${imageWidth}px` }}>
      <Image
        src={imageUrl}
        alt={imageAlt}
        naturalHeight={imageHeight}
        naturalWidth={imageWidth}
      />
      <VerticalSpacer mobile="p-24" tablet="p-30" desktop="p-30" />
    </div>
  );
};

TwoColImage.propTypes = {
  imageAlt: PropTypes.string,
  imageHeightDesktop: PropTypes.number,
  imageHeightMobile: PropTypes.number,
  imageUrlDesktop: PropTypes.string,
  imageUrlMobile: PropTypes.string,
  imageWidthDesktop: PropTypes.number,
  imageWidthMobile: PropTypes.number,
  size: PropTypes.oneOf(['', 'sm', 'md', 'lg']),
};

TwoColImage.defaultProps = {
  imageAlt: '',
  imageHeightDesktop: '',
  imageHeightMobile: '',
  imageUrlDesktop: '',
  imageUrlMobile: '',
  imageWidthDesktop: '',
  imageWidthMobile: '',
};

TwoColImage.getEditingConfig = () => [
  stringInputSpec('imageUrlDesktop', 'Image URL'),
  stringInputSpec('imageHeightDesktop', 'Image height in pixels'),
  stringInputSpec('imageWidthDesktop', 'Image width in pixels'),
  stringInputSpec('imageUrlMobile', 'Image URL just for mobile (optional)'),
  stringInputSpec(
    'imageHeightMobile',
    'Image height just for mobile (optional)'
  ),
  stringInputSpec('imageWidthMobile', 'Image width just for mobile (optional)'),
  stringTextAreaSpec('imageAlt', 'Text description for screenreader'),
];

TwoColImage.displayName = 'TwoColImage';

export default TwoColImage;
